import React from 'react';
import PropTypes from 'prop-types';
import toLower from 'lodash/toLower';
import { LowQuality, GoodQuality, HighQuality } from './styled';
import { LOW_QUALITY, GOOD_QUALITY, HIGH_QUALITY } from './constants';

/**
 * Feedback
 * @param type {string}
 * @returns {JSX.Element}
 */
const Feedback = ({ type = 'Low Quality' }) => {
  const feedbackType = toLower(type);
  return (
    <>
      {feedbackType === 'low quality' && <LowQuality>{LOW_QUALITY}</LowQuality>}
      {feedbackType === 'good quality' && (
        <GoodQuality>{GOOD_QUALITY}</GoodQuality>
      )}
      {feedbackType === 'high quality' && (
        <HighQuality>{HIGH_QUALITY}</HighQuality>
      )}
    </>
  );
};

Feedback.propTypes = {
  type: PropTypes.string
};

export default Feedback;
